import React from "react";
import Cx from "classnames";
import { observer, inject } from "mobx-react";
import { TextBox, ValidatedTextBox } from "argon-toolbox/lib/textbox";
import Label from "argon-toolbox/lib/label";
import Button from "argon-toolbox/lib/button";

import styles from "./style.css";

class App extends React.Component {
	render() {
		const {
			number,
			name,
			email,
			phone,
			validationErrors,
			isProcessing
		} = this.props.app;
		const { setField, process } = this.props.app;

		return (
			<div
				className={Cx("animated fadeInUp", styles.app)}
				data-animation="animated fadeInUp"
			>
				<div className={styles.inner}>
					<div className={styles.line}>
						<ValidatedTextBox
							placeholder="CUI* (ex. 12345678)"
							className={styles.bigText}
							value={number}
							onChange={value => setField({ number: value })}
							hasError={validationErrors.number}
							message="CUI invalid"
							messageClassName={styles.error}
							onEnter={process}
						/>
					</div>
					<div className={styles.line}>
						<span className={styles.orLabel}>SAU</span>
					</div>
					<div className={styles.line}>
						<ValidatedTextBox
							placeholder="Denumire* (ex. Company SRL)"
							className={styles.bigText}
							value={name}
							onChange={value => setField({ name: value })}
							hasError={validationErrors.name}
							message="Nume invalid"
							messageClassName={styles.error}
							onEnter={process}
						/>
					</div>
					<div className={styles.line}>
						<TextBox
							placeholder="Email (ex. office@company.ro)"
							className={styles.bigText}
							value={email}
							onChange={value => setField({ email: value })}
							hasError={validationErrors.email}
							message="Email invalid"
							messageClassName={styles.error}
							onEnter={process}
						/>
					</div>
					<div className={styles.line}>
						<TextBox
							placeholder="Telefon (ex. 07xxxxxxxx)"
							className={styles.bigText}
							value={phone}
							onChange={value => setField({ phone: value })}
							hasError={validationErrors.phone}
							message="Telefon invalid"
							messageClassName={styles.error}
							onEnter={process}
						/>
					</div>
					<div className={styles.line}>
						<Button
							label={
								!isProcessing
									? "Proceseaza"
									: "Se proceseaza ..."
							}
							full
							raised
							className={styles.bigButton}
							onClick={process}
							disabled={isProcessing}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default inject(store => ({
	app: store.app
}))(observer(App));
